"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShade = void 0;
var _tsUtils = require("@ori/ts-utils");
const mapShade = ({
  colorImageUrl,
  productCode,
  shadeName,
  hexColors
}) => {
  const props = {
    productCode: productCode ?? '',
    hexColors: hexColors ? hexColors.filter(_tsUtils.isNonNullable) : undefined
  };
  if (colorImageUrl) {
    props.imageUrl = colorImageUrl;
  }
  if (shadeName) {
    props.shadeName = shadeName;
  }
  return props;
};
exports.mapShade = mapShade;
//# sourceMappingURL=mapShade.js.map